import { connect } from 'react-redux'
import Materials from './materials'
import {
  getUser,
  getFetchUserRequest
} from '../../../stores/user/user.selectors'
import { fetchUser } from '../../../stores/user/user.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { me, meRequest }) => {
  const fetchUserRequest = getFetchUserRequest(state)
  const user = getUser(state)
  return {
    pending: fetchUserRequest.pending,
    isSchoolLeaderInPobbleSchool:
      user &&
      user.teacher_type &&
      user.teacher_type.school_leader &&
      user.teacher_type.school &&
      user.teacher_type.school.pobble_school
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => {
    dispatch(fetchUser()).catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Materials)
